export default "__VITE_ASSET__237b93f7__"